<script>
	import {API} from '../global.js'
	import {USER} from '../store.js'
	import FormasPago from './formas-pago.svelte'
	import { setContext } from 'svelte';

	export let data = {}
 

	let tipoRDA = ''
	let tipoRDE = ''
	let formaPagoOn = false

	let cobranza = {}

	let anioActual = (new Date()).getFullYear()
	let anioPrevio = (new Date()).getFullYear()-1
	
	setContext('eje',data.info.IdEjecutivo||'')

	$: refresh = async () => {
		let rs = await fetch(`${API}/cliente-cear/${data.info.IdCliente}`)
		let ds = await rs.json()
		setTipos(ds.optipo)
		return ds
	}

	function setTipos(tipos){
		tipoRDA = (tipos.filter(v => v.idhotel===1))[0]?.tipo || '----'
		tipoRDE = (tipos.filter(v => v.idhotel===2))[0]?.tipo || '----'
	}

	function setCobranza(cb){
		//console.log($USER.aclist=='cliente')
		cobranza = cb
		cobranza.RazonSocial = data.info.RazonSocial
		
		formaPagoOn = true
	}
	//{username: 'CCALOMI', fullname: 'CRISTIAN CALOMINO', aclist: 'CAJA,VER-PRESENTACIONES,VER-TIPO-COB,CAJAxR,CAJAAR'}
	//{usuario: '5000', apellido: 'POLLONO', nombre: 'JORGE ALBERTO ', email: 'crisal72@yahoo.com.ar', tipo: 'Titular', …}

</script>

<div class="container pb-4">
	<h3>Cuota Especial de Actualización del Resort (CEAR)</h3>
	{#await refresh()}
		<div class="spinner-border" role="status">
			<span class="visually-hidden">Loading...</span>
	  	</div>
	{:then result}
		{#if result.rda.length}
			<div class="card my-3  marco">
				<div class="card-header d-flex justify-content-between">
					<h5 class="fw-bolder">Rincon de los Andes</h5>
					<span class="text-end">$ {result.rda_saldo.toFixed(2)}
						<button class="btn btn-sm btn-danger fw-bold ms-3" 
							on:click={()=>setCobranza({
											idcliente : data.info.IdCliente,
											importe : result.rda_saldo.toFixed(2), 
											idmoneda:1, 
											simbolo:'$',
											tipocli:tipoRDA,
											sociedad:'4',
											idcomplejo:'1',
											complejo:'Rincon de los Andes',
											cobranza:'CEAR'
										})}>Opciones de Pago
						</button>
						<!--  disabled={parseFloat(result.rda_saldo)<1} -->
					</span>
				</div>
				<div class="card-body py-2">
					<details>
						<summary class="text-primary fst-italic p-2 mx-1" tabindex="-1">
							<i>Detalles</i>
						</summary>
						{#each result.rda as item, index}
							<div class="row mx-2 py-2 border-top">
								<div class="col-sm-2 col-12"><b>{item.Cuota || item.cuota}</b></div>
								<div class="col-2 text-center">{item.Simbolo}</div>
								<div class="col-sm-3 col-10 text-end">{item.APagar.toFixed(2)}</div>
								<div class="col-sm-3 col-12 text-end text-nowrap">{(item.Saldo>1 && item.SaldoSFP<1)?'(Adh.)':''}&nbsp;{item.Saldo.toFixed(2)}</div>
								<div class="col-2 d-sm-none fw-bold">Saldo</div>
								<div class="col-sm-2 col-10 text-end"><b>{item.SaldoSFP.toFixed(2)}</b></div>
							</div>
						{/each}	
					</details>
				</div>
			</div>
		{/if}
		<br>
		{#if result.rde.length}
			<div class="card my-3 marco">
				<div class="card-header d-flex justify-content-between">
					<h5 class="fw-bolder">Rincon del Este</h5>
					<span class="text-end">U$s {result.rde_saldo.toFixed(2)}
						<button class="btn btn-sm btn-danger fw-bold ms-3" 
							on:click={()=>setCobranza({
											idcliente : data.info.IdCliente,
											importe : result.rde_saldo.toFixed(2), 
											idmoneda:2, 
											simbolo:'U$s',
											tipocli:tipoRDE,
											sociedad:'4',
											idcomplejo:'2',
											complejo:'Rincon del Este',
											cobranza:'CEAR'
										})}>Opciones de Pago
						</button>
						<!-- el boton anterior estaba deshabilitado se importe era 0 ---  [disabled={parseFloat(result.rde_saldo)<1}] -->
					</span>
				</div>
				<div class="card-body py-2">
					<details>
						<summary class="text-primary fst-italic p-2 mx-1" tabindex="-1">
							<i>Detalles</i>
						</summary>
						{#each result.rde as item, index}
							<div class="row mx-2 py-2 border-top">
								<div class="col-sm-2 col-12"><b>{item.Cuota || item.cuota}</b></div>
								<div class="col-2 text-center">{item.Simbolo}</div>
								<div class="col-sm-3 col-10 text-end">{item.APagar.toFixed(2)}</div>
								<div class="col-sm-3 col-12 text-end">{(item.Saldo>1 && item.SaldoSFP<1)?'(Adh.)':''}&nbsp;{item.Saldo.toFixed(2)}</div>
								<div class="col-2 d-sm-none fw-bold">Saldo</div>
								<div class="col-sm-2 col-10 text-end"><b>{item.SaldoSFP.toFixed(2)}</b></div>
							</div>
						{/each}	
					</details>
				</div>
			</div>
		{/if}
		{#if !result.rde.length && !result.rda.length}
			<p class="m-4">No se registran importes de CAM</p>
		{/if}
	{/await}

</div>


{#if formaPagoOn}
	<div class="overlay">
		<!--button class="btn btn-danger float-end m-2" id on:click={()=>formaPagoOn=false} ><b>&Cross;</b></button-->
		<FormasPago {cobranza} on:close={()=>formaPagoOn=false}/> 
	</div>
{/if}

<style>
	.marco{
		border: solid 4px #cccccc;
	}
</style>